module.exports = __webpack_public_path__ + "static/header.mobile-674a036ae0ddf742a76fa24effd1ddb4.jpg";